import styles from "./ArticleBooksDropdown.module.scss";
import { BookReview } from "types/api";
import cx from "classnames";

const ArticleBooksDropdown = ({
  index,
  toggleMenu,
  showDrop,
  bookshopIsbn,
  asin,
  title,
  insetOrMobile,
  blurFunc,
  modulePosition,
}: {
  index: number;
  toggleMenu: () => void;
  showDrop: boolean | undefined;
  insetOrMobile: boolean;
  blurFunc: () => void;
  modulePosition: "end of article" | "inline";
} & Pick<BookReview, "bookshopIsbn" | "asin" | "title">) => {
  return (
    <div
      className={cx(styles.root, styles.menuContainer)}
      onBlur={(e) => {
        //if div DOES NOT contain the element receiving focus, execute blur func
        if (!e.currentTarget.contains(e.relatedTarget as Node)) {
          blurFunc();
        }
      }}
    >
      <button
        className={cx(
          styles.button,
          showDrop && styles.activeButton,
          insetOrMobile ? styles.insetOrMobileButton : styles.fullWidthButton
        )}
        onClick={() => toggleMenu()}
        aria-haspopup={true}
        aria-controls={`expanded-buy-books-menu-${index}`}
        aria-expanded={showDrop}
        aria-label={showDrop ? "Close Buy Book Menu" : "Open Buy Book Menu"}
        data-action={`click ${
          showDrop ? "close" : "expand"
        } - ${modulePosition} affiliate promo - ${index + 1}`}
        data-label={title}
      >
        Buy Book
      </button>

      {showDrop && (
        <ul
          id={`expanded-buy-books-menu-${index}`}
          className={styles.dropDownContainer}
        >
          {/* AMAZON BUTTON */}
          <li>
            <a
              href={`https://www.amazon.com/dp/${asin}/?tag=theatl0c-20`}
              target="_blank"
              data-action={`click link - ${modulePosition} affiliate promo - ${
                index + 1
              } - amazon`}
              data-label={title}
              rel="noopener noreferrer"
            >
              Amazon
            </a>
          </li>
          {/* BOOKSHOP BUTTON */}
          {bookshopIsbn && (
            <li>
              <a
                href={`https://bookshop.org/a/12476/${bookshopIsbn}`}
                target="_blank"
                rel="noopener noreferrer"
                data-action={`click link - ${modulePosition} affiliate promo - ${
                  index + 1
                } - bookshop`}
                data-label={title}
              >
                Bookshop
              </a>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default ArticleBooksDropdown;
